export const generateHeaderTitles = ({ sideMenuConfig }) => {
  const headerTitles = {};
  sideMenuConfig.forEach(
    ({ label: parentLabel, path: parentPath, children }) => {
      if (!children) {
        headerTitles[`/${parentPath}`] = parentLabel;
      } else {
        children.forEach(({ label: childrenLabel, path: childPath }) => {
          headerTitles[`/${parentPath}/${childPath}`] = childrenLabel;
        });
      }
    },
  );

  return { headerTitles };
};
